export default __webpack_public_path__ + "static/media/crispLogo.5b08052c.png";